import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {closeMenu as closeRhsMenu} from 'actions/views/rhs';

import TutorialTip from './tutorial_tip.jsx';

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            closeRhsMenu,
        }, dispatch),
    };
}

export default connect(null, mapDispatchToProps)(TutorialTip);



// WEBPACK FOOTER //
// ./components/tutorial/tutorial_tip/index.js